import Model from 'mixins/model';

export default class ArticleNotificationModel extends Model {
    static fromJSON(data) {
        const {
          title,
          createdAt,
          photo,
          url,
          newWindow,
        } = data;

        const model = new ArticleNotificationModel();

        model.set('title', title);
        model.set('createdAt', createdAt);
        model.set('photo', photo);
        model.set('url', url);
        model.set('newWindow', newWindow);

        return model;
    }
};



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/models/ArticleNotificationModel.js